import React, { useEffect, useState } from 'react'
import * as Types from 'types'
import { Card, ProfileCompletionBar } from 'components'
import { buildBarModel } from '../../profile/profile-completion-sections'

const propTypes = {
  artist: Types.artist.isRequired,
}

function ProfileCompletionCard({ artist }) {
  const [, setBarVersion] = useState(0)

  useEffect(() => {
    const onProfileCompletionUpdated = () => {
      setBarVersion((prev) => prev + 1)
    }
    if (typeof window !== 'undefined') {
      window.addEventListener(
        'artist-profile-completion-updated',
        onProfileCompletionUpdated
      )
    }
    return () => {
      if (typeof window !== 'undefined') {
        window.removeEventListener(
          'artist-profile-completion-updated',
          onProfileCompletionUpdated
        )
      }
    }
  }, [])

  const { sections, completedSections, percent } = buildBarModel(artist)

  return (
    <Card>
      <ProfileCompletionBar
        variant="card"
        percent={percent}
        completedSections={completedSections}
        sections={sections}
      />
    </Card>
  )
}

ProfileCompletionCard.propTypes = propTypes

export default ProfileCompletionCard
